import { ThemeContext, ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import React, { useContext, ReactElement } from "react";
import theme, { ITheme } from "./theme";

interface IThemeProviderProps {
  theme: ITheme;
  children: ReactElement | ReactElement[];
}
const ThemeProvider: React.FC<IThemeProviderProps> = ({ theme, children }: IThemeProviderProps) => (
  <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
);

ThemeProvider.defaultProps = {
  theme,
};

const useTheme = () => {
  const theme = useContext<ITheme>(ThemeContext as any);

  if (theme === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return theme;
};

export default ThemeProvider;

export { useTheme };
